/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetScriptContentQuery } from "~/generated/graphql";

type Props = {
  actionId?: string;
  enabled?: boolean;
};

export function useGetScriptContent({ actionId, enabled = true }: Props) {
  const skip = !enabled || !actionId;
  const { data, loading, error } = useGetScriptContentQuery({
    variables: { actionId: actionId ?? "" },
    skip,
    fetchPolicy: "network-only",
  });

  return {
    scriptContent: data?.scriptContent ?? "",
    loading,
    error,
  } as const;
}
